import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import axios from 'axios';
import Loader from '../components/Loader';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
const Wrapper = styled.div`
  min-height: 100vh;
  width: 100vw;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FormBox = styled.form`
  background: #fff;
  width: 400px;
  padding: 2.5rem 2.2rem;
  border-radius: 12px;
  box-shadow: 0 2px 18px rgba(35,62,88,0.07);
  display: flex;
  flex-direction: column;
  border: 1px solid #e9e9e9;
`;

const Title = styled.h2`
  color: #20294d;
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 2px;
  margin-top: 0;
  font-family: 'Inter', Arial, sans-serif;
`;

const Subtitle = styled.div`
  color: #7a7e86;
  font-size: 1.01rem;
  margin-bottom: 1.55rem;
  font-weight: 400;
  font-family: 'Inter', Arial, sans-serif;
`;

const Label = styled.label`
  color: #20294d;
  font-size: 0.97rem;
  font-weight: 700;
  margin-bottom: 0.32rem;
  margin-top: 0.6rem;
  font-family: 'Inter', Arial, sans-serif;
`;

const Input = styled.input`
  border: 1px solid #d1d5db;
  border-radius: 8px;
  height: 42px;
  font-size: 1.03rem;
  padding: 0 1rem;
  margin-bottom: 1.1rem;
  font-family: 'Inter', Arial, sans-serif;
  background: #fff;
  transition: border-color 0.18s linear;

  &:focus {
    border-color: #3772FF;
    outline: none;
  }
`;

const Button = styled.button`
  background: #3772FF;
  color: #fff;
  border: none;
  height: 44px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.01rem;
  margin-top: 2px;
  margin-bottom: 2.2rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #2462dc;
  }
`;

const HelperLink = styled.a`
  text-align: center;
  display: block;
  font-size: 0.95rem;
  color: #3772FF;
  margin-bottom: 1.9rem;
  text-decoration: none;
  font-family: 'Inter', Arial, sans-serif;

  &:hover {
  }
`;

export default function SignIn() {

 
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
const handleSignIn = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError("");

  const hostname = window.location.hostname;
  const isInventoryDomain = hostname === 'inventory.fescafe.in' || hostname === 'localhost';
  const isRecordsDomain = hostname === 'records.fescafe.in' ;

  try {
    const response = await axios.post(`${BACKEND_URL}/auth/signin`, {
      username: email,
      password
    });

    const { session, user } = response.data;
    localStorage.setItem('access_token', session.access_token);
    localStorage.setItem('user', JSON.stringify(user));

    if (!user.set_password) {
      navigate('/reset-password');
      return;
    }

    const roleName = user.roles?.role_name;

    if (roleName === "SUPER_ADMIN") {
      if (isRecordsDomain) {
        navigate('/dashboard');
      } else if (isInventoryDomain) {
        navigate('/inventory/entries');
      } else {
        navigate('/dashboard'); // fallback
      }
    } else if (roleName === "STORE_MANAGER") {
      if (isRecordsDomain) {
        navigate('/cashflow');
      } else if (isInventoryDomain) {
        navigate('/inventory/entries');
      } else {
        navigate('/cashflow'); // fallback
      }
    } else {
      if (isInventoryDomain) {
        alert('Only Store Managers and Admins allowed on inventory app.');
        // Optionally redirect to sign-in or home here
      } else {
        navigate('/cashflow');
      }
    }
  } catch (err) {
    console.error(err);
    setError(err.response?.data?.error || 'Sign in failed');
  } finally {
    setLoading(false);
  }
};


    return (
        <Wrapper>
          {loading && <Loader/>}
            <FormBox onSubmit={handleSignIn}>
                <Title>Sign In</Title>
                <Subtitle>Sign in to your café account</Subtitle>

                {error && <p style={{color:'red', fontSize:'0.9rem'}}>{error}</p>}

                <Label htmlFor="email">Username</Label>
                <Input 
                    id="email" 
                    type="text" 
                    placeholder="Username" 
                    required 
                    value={email} 
                    onChange={(e)=>setEmail(e.target.value)} 
                />

                <Label htmlFor="password">Password</Label>
                <Input 
                    id="password" 
                    type="password" 
                    placeholder="Password" 
                    required 
                    value={password} 
                    onChange={(e)=>setPassword(e.target.value)} 
                />

                <Button type="submit" disabled={loading}>
                    {loading ? "Signing In..." : "Sign In"}
                </Button>

              
            </FormBox>
        </Wrapper>
    );
}
